import { useEffect, useRef } from 'react';

// Gliding hover highlight: one frosted-glass `.nav-glider` element inside the
// container slides (with a slight spring) to whichever item (`itemSelector`)
// the pointer is over, and fades out when the pointer leaves. The container
// must be `position: relative` so the items' offsetTop/offsetLeft are measured
// from it; the glider lives in the scroll content, so it scrolls with the items.
export function useNavGlider(itemSelector = '.dock-item') {
  const ref = useRef(null);

  useEffect(() => {
    const nav = ref.current;
    const glider = nav?.querySelector(':scope > .nav-glider');
    if (!nav || !glider) return undefined;

    let shown = false;
    const over = (e) => {
      const item = e.target.closest(itemSelector);
      if (!item || !nav.contains(item)) return;
      // First appearance: jump into place without sliding in from the last spot.
      if (!shown) glider.style.transition = 'none';
      glider.style.width = `${item.offsetWidth}px`;
      glider.style.height = `${item.offsetHeight}px`;
      glider.style.borderRadius = getComputedStyle(item).borderRadius;
      glider.style.transform = `translate(${item.offsetLeft}px, ${item.offsetTop}px)`;
      if (!shown) {
        void glider.offsetWidth; // commit the jump before re-enabling transitions
        glider.style.transition = '';
        shown = true;
      }
      glider.classList.add('is-on');
    };
    const leave = () => {
      shown = false;
      glider.classList.remove('is-on');
    };

    nav.addEventListener('mouseover', over);
    nav.addEventListener('mouseleave', leave);
    return () => {
      nav.removeEventListener('mouseover', over);
      nav.removeEventListener('mouseleave', leave);
    };
  }, [itemSelector]);

  return ref;
}
